import { environment } from './../../../../../../environment/environment';
import { CompanyService } from './../../../../../core/services/company/company.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-details-clients',
  templateUrl: './details-clients.component.html',
  styleUrls: ['./details-clients.component.css'],
})
export class DetailsClientsComponent {
  /* number */
  tabulation: number = 10;
  /* boolean */
  disabledMode: boolean = true;
  /* object */
  esnDetails: any;
  esndetailclient: any;
  /* string */
  idEsn!: string;
  nameEsn!: string;
  url: string = environment.baseUrl + '/api';

  /* formGroup */
  companyDetailsForm: FormGroup = this.createCompanyDetailsForm();
  /* unsubscription */
  id = this.activatedRoute.snapshot.params['id'];
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    this.getEsnById();
  }

  /* get esn details */
  getEsnById() {
    this.spinner.show();
    this.companyService.getCompanydetail(this.id).subscribe({
      next: (res: any) => {
        console.log('detail company', res);

        this.spinner.hide();
        this.nameEsn = res.data[0].name;
        console.log('this.nameEsn', this.nameEsn);
        this.esnDetails = res.data[0];
        this.esndetailclient = res;
        console.log(
          'esndetailclient',
          this.esndetailclient.prestationDaysLastMonth
        );
        this.companyDetailsForm = this.createCompanyDetailsForm(res.data[0]);
        console.log('companyDetailsForm', this.companyDetailsForm);

        this.companyDetailsForm.disable();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  /* create add subCategory form */
  createCompanyDetailsForm(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : '', [Validators.required]],
      type: [data ? data.type : null, [Validators.required]],
      linkedin_link: [data ? data.linkedin_link : '', [Validators.required]],
      website_link: [data ? data.website_link : '', [Validators.required]],
      logo: [data ? data.logo : ''],
    });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  contactResponsableNavigation(id: any) {
    this.router.navigate(['/contact', { idResponsable: id }]);
  }
  VoiroffreNavigation(id: any) {
    this.router.navigate(['/entreprises/offre-entreprise', { id: id }]);
  }
  VoirconsultantNavigation(id: any) {
    this.router.navigate(['/nos-clients/listconsultant/' + id]);
  }

  contacterEntreprise(id: any) {
    this.router.navigate(['/contacterEntreprise', { id: id }]);
  }

   
}
